import { Link } from 'react-router-dom'

interface EmptyProps {
	title: string
	image: string
	link: {
		text: string
		link?: string
		combinedLink?: string
	}
}

export function Empty({ title, image, link }: EmptyProps) {
	return (
		<div className='flex gap-6 items-center'>
			<img
				src={image}
				alt='Emoji'
				className='w-[105px] h-auto hidden md:flex'
			/>

			<div className='flex flex-col gap-[6px]'>
				<p className='font-medium text-base md:text-xl leading-[135%] md:leading-[104%] text-zinc-50'>
					{title}
				</p>
				<p className='flex text-base text-white/70 leading-[155%]'>
					{link.link ? (
						<Link to={link.link} className='underline font-medium'>
							{link.text}
						</Link>
					) : (
						<span className='font-medium'>{link.text}</span>
					)}{' '}
					<span className='hidden md:inline'>{link.combinedLink}</span>
				</p>
			</div>
		</div>
	)
}
